import { render } from "./Tutorial.vue?vue&type=template&id=897806dc&lang=pug"
import script from "./Tutorial.vue?vue&type=script&lang=js"
export * from "./Tutorial.vue?vue&type=script&lang=js"

import "./Tutorial.vue?vue&type=style&index=0&id=897806dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__